import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReportsService } from '@hosty-app/services';

import { ReportsStoreEffects } from './reports-store.effects';
import { reducer, reportsStoreFeatureKey } from './reports-store.reducers';

export function provideReportsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(reportsStoreFeatureKey, reducer),
    provideEffects([ReportsStoreEffects]),
    ReportsService,
  ]);
}
